import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { trackingSubscribeFailed, trackingSubscribeSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_URL } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* trackingSubscribe(action) {
  try {
    const { filters, bounds } = action.payload;
    const pool = { bounds };
    if (typeof filters === 'object' && Object.keys(filters).length) {
      pool.filters = addFilterQueryWithCondition(filters, {});
    }
    const url = `${BACKEND_URL}/tracking/subscribe`;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(trackingSubscribeSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      yield put(trackingSubscribeFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(trackingSubscribeFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
